import Text from './Text.styled'

export default Text
